/* globals translation */

import { closestByClassName } from './functions';

const modules = Array.from(document.querySelectorAll('section.module > .content'));
const mobileWidth = 850;

const calcModuleContentSpace = () => {
  modules.forEach((module) => {
    let { paddingTop, paddingBottom } = module.style;
    const element = module;

    if (paddingTop || paddingBottom) {
      if (window.innerWidth <= mobileWidth && !element.classList.contains('modified')) {
        if (paddingTop) {
          // Store the original padding as a data attribute
          element.dataset.OgPaddingTop = paddingTop;

          // Convert to number and divide by two
          paddingTop = parseInt(paddingTop, 10);
          element.style.paddingTop = `${paddingTop / 2}px`;
        }

        if (paddingBottom) {
          // Store the original padding as a data attribute
          element.dataset.OgPaddingBottom = paddingBottom;

          // Convert to number and divide by two
          paddingBottom = parseInt(paddingBottom, 10);
          element.style.paddingBottom = `${paddingBottom / 2}px`;
        }

        // Add modified class to prevent double calculations
        element.classList.add('modified');
      } else if (window.innerWidth > mobileWidth && element.classList.contains('modified')) {
        const { OgPaddingTop, OgPaddingBottom } = element.dataset;

        if (paddingTop) {
          element.style.paddingTop = OgPaddingTop;
        }

        if (paddingBottom) {
          element.style.paddingBottom = OgPaddingBottom;
        }

        // Remove the modified class to prevent doubling
        element.classList.remove('modified');
      }
    }
  });
};

calcModuleContentSpace();
window.addEventListener('resize', () => calcModuleContentSpace());

if (modules) {
  modules.forEach((moduleContent) => {
    const module = moduleContent.parentNode;
    if (module.classList.contains('without-overlaying-header')) {
      document.body.classList.add('no-header-overlay');
    }
  });
}

const findProductsForms = Array.from(document.querySelectorAll('form.find-products-module'));
if (findProductsForms.length > 0) {
  findProductsForms.forEach((form) => {
    // eslint-disable-next-line consistent-return
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const productCat = form.querySelector('select[name="product_cat"]');
      const skinType = form.querySelector('select[name="pa_skin"]');
      const parentContainer = closestByClassName(form, 'module-find-product');

      if (productCat.value === '-1' || skinType.value === '-1') {
        alert(translation.must_choose_cat_and_skin);
        return;
      }

      parentContainer.classList.add('loading');

      // The ajax request payload
      const payload = {
        action: 'mcb_fp_get_redirect_link',
        productCat: productCat.value,
        skinType: skinType.value,
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        window.location = response;
        setTimeout(() => {
          parentContainer.classList.remove('loading');
        }, 2000);
      });
    });
  });
}


// Disabled, unused feature pausing youtube video - Client changed to self-hosted
// const getTheLook = () => {
//   const getTheLookModules = Array.from(document.querySelectorAll('.module-get-the-look'));
//   if (getTheLookModules) {
//     getTheLookModules.forEach((module) => {
//       const iframes = Array.from(module.getElementsByTagName('iframe'));
//       if (iframes) {
//         let timer = null;
//
//         module.querySelector('.item-wrapper').addEventListener('scroll', (event) => {
//           if (timer !== null) {
//             clearTimeout(timer);
//           }
//
//           timer = setTimeout(() => {
//             iframes.forEach((iframe) => {
//               iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
//             });
//           }, 300);
//         });
//       }
//     });
//   }
// };
// getTheLook();
// jQuery(document.body).on('mcb_init', getTheLook);
